var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-list',{attrs:{"media-list":""}},_vm._l((_vm.ingredients),function(ref){
var name = ref.name;
var quantity = ref.quantity;
var unit = ref.unit;
return _c('f7-list-item',{key:name,attrs:{"title":name,"after":_vm.displayQuantity(quantity, unit),"checkbox":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }